module.exports = "<xo-shipping-address token=\"token\" done-fn=\"doneFn\" sidebar=\"sidebar\"></xo-shipping-address>\n"


/*****************
 ** WEBPACK FOOTER
 ** ../~/noop-loader!./components/xo-member-components/src/select-shipping/add-shipping/template.html
 ** module id = 300
 ** module chunks = 1
 **/